import { render, staticRenderFns } from "./Lald.vue?vue&type=template&id=42c3ae65&scoped=true"
import script from "./Lald.vue?vue&type=script&lang=js"
export * from "./Lald.vue?vue&type=script&lang=js"
import style0 from "./Lald.vue?vue&type=style&index=0&id=42c3ae65&prod&lang=scss&scoped=true"
import style1 from "./Lald.vue?vue&type=style&index=1&id=42c3ae65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3ae65",
  null
  
)

export default component.exports